import { use } from 'react';

import { DropdownContext } from '../DropdownContext';
import { S } from './DropdownTrigger.styles';
import type { DropdownTriggerProps } from './DropdownTrigger.types';

export const DropdownTrigger = (props: DropdownTriggerProps) => {
  const { setReference, setIsOpen, isOpen } = use(DropdownContext);

  return (
    <S.Trigger
      type="button"
      aria-expanded={isOpen}
      aria-haspopup="true"
      ref={setReference}
      onClick={() => setIsOpen(!isOpen)}
      {...props}
    />
  );
};
